<div class="modal-header">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button type="button" class="btn close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p style="white-space: pre-line;" [innerHTML]="modalMessage"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default-ac" (click)="activeModal.close('Close click')">Cerrar</button>
</div>